import { Grid } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { Table } from "@tecsinapse/table";
import { User } from "api";
import { useUsers } from "api/hooks";
import { functions } from "config/firebaseConfig";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory } from "react-router";
import {
    BoxCard,
    ConfirmationDialog,
    FormButton,
    PageLayout,
} from "ui/componentes";
import { UserForm } from "ui/views";

const sendWelcomeEmails = (users, enqueueSnackbar) => {
    return functions
        .httpsCallable("email-sendWelcomeEmails")({
            users,
        })
        .then(() => {
            enqueueSnackbar("Emails enviados com sucesso!", {
                variant: "success",
            });
        })
        .catch((e) => console.log(e));
};

const Users = () => {
    const users = useUsers<User[]>({
        withPrivateInfo: true
    });
    users && users.sort((u1, u2) => (u1.firstName > u2.firstName ? 1 : -1));
    const { enqueueSnackbar } = useSnackbar();
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState<object[]>([]);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    return (
        <PageLayout
            title="Usuários"
            showInBoxCard={false}
            boxCardProps={{
                display: "flex",
            }}
        >
            <ConfirmationDialog
                showDialog={showConfirmation}
                message="Já foi enviado o email de boas-vindas para alguns dos usuários selecionados, deseja reenvia-los?"
                onCancel={() => setShowConfirmation(false)}
                onOk={() => {
                    setLoading(true);
                    sendWelcomeEmails(selectedUsers, enqueueSnackbar).then(() =>
                        setLoading(false)
                    );
                    setShowConfirmation(false);
                }}
            />
            <Grid container spacing={1}>
                <Grid item xs={12} sm={4} md={3}>
                    <UserForm />
                </Grid>
                <Grid container item xs={12} sm={8} md={9} spacing={1}>
                    <Grid item xs={12}>
                        <FormButton
                            loading={loading}
                            onClick={() => {
                                const showConfirmation = selectedUsers.some(
                                    (user) => {
                                        return user["privateInfo"]
                                            ?.welcomeEmail;
                                    }
                                );

                                if (showConfirmation) {
                                    setShowConfirmation(true);
                                } else {
                                    setLoading(true);
                                    sendWelcomeEmails(
                                        selectedUsers,
                                        enqueueSnackbar
                                    ).then(() => setLoading(false));
                                }
                            }}
                            disabled={selectedUsers.length === 0}
                            color="primary"
                        >
                            Enviar email de boas vindas
                        </FormButton>
                    </Grid>
                    <Grid item xs={12}>
                        <BoxCard padding={0}>
                            <Table
                                columns={[
                                    {
                                        title: "Nome",
                                        field: "displayName",
                                        options: {
                                            filter: true,
                                        },
                                    },
                                    {
                                        title: "Email",
                                        field: "privateInfo.email",
                                        options: {
                                            filter: true,
                                        },
                                        customRender: (user) =>
                                            user["privateInfo"]?.email,
                                    },
                                    {
                                        title: "iRacing ID",
                                        field: "driverInfo.iracingId",
                                        options: {
                                            filter: true,
                                        },
                                        customRender: (user) =>
                                            user["driverInfo"]?.iracingId,
                                    },
                                    {
                                        title: "Email de boas-vindas",
                                        field: "privateInfo.welcomeEmail",
                                        customRender: (user) =>
                                            user["privateInfo"]?.welcomeEmail
                                                ? "Enviado"
                                                : "Não enviado",
                                    },
                                ]}
                                data={users}
                                actions={[
                                    {
                                        icon: <Edit />,
                                        tooltip: "Editar piloto",
                                        onClick: (user) => {
                                            history.push(
                                                `/profile/${user["id"]}`
                                            );
                                        },
                                    },
                                ]}
                                options={{
                                    selection: true,
                                }}
                                pagination={true}
                                onSelectRow={setSelectedUsers}
                                rowId={(row) => row["id"]}
                                onDrawerClose={() => {
                                    return;
                                }}
                            />
                        </BoxCard>
                    </Grid>
                </Grid>
            </Grid>
        </PageLayout>
    );
};

export { Users };
export default Users;
